import { render, staticRenderFns } from "./StoryButtonSettings.vue?vue&type=template&id=a40707d0&scoped=true"
import script from "./StoryButtonSettings.vue?vue&type=script&lang=js"
export * from "./StoryButtonSettings.vue?vue&type=script&lang=js"
import style0 from "./StoryButtonSettings.vue?vue&type=style&index=0&id=a40707d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40707d0",
  null
  
)

export default component.exports